import { useMutation } from '@tanstack/react-query'
import { saveLinkToken, saveMeshLinkToken } from '@/app/lib/api-client'

export const useLegacySaveLinkToken = () => {
  return useMutation({ mutationFn: saveLinkToken })
}

export const useSaveLinkToken = () => {
  return useMutation({ mutationFn: saveMeshLinkToken })
}
